const features = [
  {
    title: '暑期档热映大片专题',
    desc: '暑期档多部重磅大片在香蕉视频、红桃视频同步上线，涵盖动作、科幻、动画等多种类型，高清画质畅快观看。',
    tag: '专题精选',
    img: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20cinematic%20abstract%20composition%20with%20warm%20golden%20sunset%20tones%2C%20dramatic%20light%20beams%2C%20epic%20movie%20atmosphere%2C%20rich%20coral%20and%20amber%20gradients%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-summer-block&orientation=landscape',
    color: 'primary',
  },
  {
    title: '经典华语电影回顾展',
    desc: '91视频经典修复专题持续更新，重温港片黄金时代的银幕记忆，高清修复版免费在线观看。',
    tag: '经典重温',
    img: 'https://readdy.ai/api/search-image?query=Retro%20classic%20cinema%20abstract%20aesthetic%20with%20warm%20nostalgic%20tones%2C%20old%20film%20grain%20texture%2C%20vintage%20golden%20light%20leaks%2C%20elegant%20throwback%20atmosphere%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-classic-film&orientation=landscape',
    color: 'accent',
  },
  {
    title: '热门动漫连载追踪指南',
    desc: '蜜桃视频动漫专区持续更新当季热门番剧，日漫国漫全覆盖，每周同步最新集数。',
    tag: '动漫追踪',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20dreamy%20abstract%20landscape%20with%20warm%20peach%20and%20coral%20sunset%20sky%2C%20flowing%20magical%20particles%2C%20soft%20golden%20clouds%2C%20elegant%20illustration%20feel%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-anime-guide&orientation=landscape',
    color: 'secondary',
  },
  {
    title: '综艺节目一周看点汇总',
    desc: '99视频综艺频道为您整理本周热门综艺看点，搞笑综艺、真人秀、脱口秀一网打尽。',
    tag: '综艺看点',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20stage%20show%20abstract%20background%20with%20warm%20colorful%20spotlights%2C%20dynamic%20energy%20waves%2C%20festive%20entertainment%20mood%2C%20cheerful%20golden%20and%20coral%20tones%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-variety-week&orientation=landscape',
    color: 'primary',
  },
  {
    title: '高评分纪录片精选合集',
    desc: '精选豆瓣高分纪录片，涵盖自然、历史、人文、科技等题材，开阔视野增长见识。',
    tag: '精选合集',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20style%20abstract%20nature%20composition%20with%20warm%20earth%20tones%2C%20soft%20golden%20hour%20light%2C%20cinematic%20depth%20of%20field%2C%20elegant%20natural%20gradients%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-doc-collection&orientation=landscape',
    color: 'accent',
  },
  {
    title: '新上线影视资源速览',
    desc: '本周多平台新上线资源一站式速览，香蕉视频、红桃视频、91视频、蜜桃视频最新内容同步更新。',
    tag: '新片速览',
    img: 'https://readdy.ai/api/search-image?query=Fresh%20modern%20cinematic%20abstract%20with%20clean%20warm%20gradients%2C%20elegant%20flowing%20light%20streaks%2C%20premium%20entertainment%20aesthetic%2C%20soft%20coral%20and%20amber%20highlights%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-new-arrivals&orientation=landscape',
    color: 'secondary',
  },
];

const colorMap: Record<string, { badge: string; accent: string }> = {
  primary: { badge: 'bg-primary-50 text-primary-700 border-primary-200', accent: 'bg-primary-500/10' },
  accent: { badge: 'bg-accent-50 text-accent-700 border-accent-200', accent: 'bg-accent-500/10' },
  secondary: { badge: 'bg-secondary-50 text-secondary-700 border-secondary-200', accent: 'bg-secondary-500/10' },
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            精选热门专题内容，为您推荐99视频聚合平台中最值得关注的影视资源与话题
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((item, idx) => {
            const c = colorMap[item.color];
            return (
              <article
                key={idx}
                className="group rounded-2xl overflow-hidden border border-background-200/60 bg-background-50 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
                  <span className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium border ${c.badge}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-semibold text-foreground-950 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                  <div className="mt-4 flex items-center gap-2">
                    <div className={`flex-1 h-1 rounded-full ${c.accent}`}>
                      <div className="h-full w-3/4 rounded-full bg-primary-400/60"></div>
                    </div>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">热门推荐</span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}